import { $AuthApi } from '@services';

export const trashFilesApi = {
  getFilesInTrash: async () => $AuthApi.get(`/files/trashbin`)
};
